module.exports = __webpack_public_path__ + "components/flag/static/square/ao-23ed4a47611a84019835c31a1badfef0.svg";